import './style.css';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import GeoJSON from 'ol/format/GeoJSON';
import { Projection } from 'ol/proj';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { DragBox, Select } from 'ol/interaction.js';
import { platformModifierKeyOnly } from 'ol/events/condition.js';
import { defaults as defaultControls, Control } from "ol/control";
import { ScaleLine } from 'ol/control.js';
import { saveAs } from 'file-saver';

var fileUrls = [];
var fileNames = [];


var projection = new Projection({
  code: 'EPSG:4326',
  units: 'degrees'
});

class HelpControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const img = document.createElement('img');
    img.src = 'images/help.png';
    img.className = 'helpimage ol-unselectable ol-control';
    img.id = 'helpimage';

    super({
      element: img,
      target: options.target,
    });

    img.addEventListener('click', this.handleHelp.bind(this), false);
  }

  handleHelp() {
    if (document.getElementById("help").style.display === "none") {
      document.getElementById("help").style.display = "block";
      document.getElementById("helpimage").style.border = "solid 3px red";
    } else {
      document.getElementById("help").style.display = "none";
      document.getElementById("helpimage").style.border = "none";
    }
  }
}

const region = new Style({
  stroke: new Stroke({
    color: 'red',
    width: 1,
  })
});

var fishnet = new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: 'index_srtm.geojson'
  }),
  style: region
});

const map = new Map({
  target: 'map',
  controls: defaultControls().extend([
    new HelpControl()
  ]),
  layers: [
    new TileLayer({
      source: new OSM()
    }), fishnet
  ],
  view: new View({
    center: [0, 0],
    projection: projection,
    zoom: 2
  })
});

// a DragBox interaction used to select features by drawing boxes
const dragBox = new DragBox({
  condition: platformModifierKeyOnly,
});

map.addInteraction(dragBox);

dragBox.on('boxend', function () {
  const boxExtent = dragBox.getGeometry().getExtent();

  var featureCount = 0;
  var features = [];
  fileUrls = [];
  fileNames = [];


  const keysSet = new Set();
  const boxFeatures = fishnet.getSource()
    .getFeaturesInExtent(boxExtent)
    .filter(
      (feature) => {
        //console.log(feature)
        featureCount++;
        let file = feature.get('location');
        let parts = file.split('/');
        file = "https://opendemdata.info/data/srtm_contour/" + parts[6];
        fileNames.push(parts[6]);
        fileUrls.push(file);


        let html = '<a href="' + file + '" title="' + file + '">' + file + '</a>';

        features.push(html);



      }

    );

  // datasets
  document.getElementById('count').innerText = features.length;
  const selected = document.getElementById('selecteddatasets');
  selected.innerHTML = '';
  for (let i = 0; i < features.length; i++) {
    selected.innerHTML += features[i] + "<br>";
  }

  var info = document.getElementById("info");
  info.style.display = 'block';
  var closer = document.getElementById("closeInfo");
  closer.style.display = 'block';

});

// close info
var closer = document.getElementById("closeInfo");
closer.onclick = function () {
  closer.style.display = 'none';
  document.getElementById("info").style.display = 'none';
};


document.getElementById("downloadbutton").addEventListener("click", function () {
  downloadFilesSequentially(0);
});

var popup;

document.getElementById("newWindow").addEventListener("click", function () {

  var divText = document.getElementById("info").outerHTML;
  divText = divText.replace('class="closeInfo"', 'style="display:none"');
  divText = divText.replace(' <p> <button id="downloadbutton" type="button">Download all files </button> May not work with all browsers and\n      settings.</p>\n    <p> <button id="newWindow" type="button">Open in a new window tab</button></p>\n', '');
  popup = window.open('', 'Download');
  var doc = popup.document;
  doc.open();
  doc.write(divText);
  doc.close();

});





// Download multiple files
function downloadFilesSequentially(index) {

  saveAs(fileUrls[index], fileNames[index]);

  if (index < fileUrls.length) {
    index++;
    downloadFilesSequentially(index)
  }
}
